import React from 'react';
import NutriList from './NutriList.js';

const DashHome = () => {
  return(
    <div className="food-wrapper">
        <NutriList />
    </div>
  )
}

export default DashHome;